
const ENV = process.env.NODE_ENV
export default {
  DOMAIN: 'http://127.0.0.1:8080',
  // baseURL: ENV == 'development'?'http://127.0.0.1:8080':'127.0.0.1:8080',
  // baseURL: "http://login.jianyanedu.cn",
  // imageURL: "http://login.jianyanedu.cn",
  baseURL: "https://zkapi.dafangongkao.com",
  imageURL: "https://zkapi.dafangongkao.com",
  util: {
    image: '/util/image.html' // 图片上传
  }
}



// WEBPACK FOOTER //
// ./src/api/api.url.js